import {api} from "../plugins/axios";
import {ScoreType, TargetType, TResponse} from "../types/types";

export const scoreUp = (targetId: number, targetType: TargetType, scoreType: ScoreType) => {
    return api.post<TResponse<void>>('/v1/score/scoreUp', { targetId, targetType, scoreType });
};


